<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md6 lg4>
            <v-card class="elevation-12">
              <v-toolbar dark color="light-blue darken-3">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="loginForm" v-model="valid" lazy-validation>
                  <v-text-field
                    prepend-icon="email"
                    name="login" label="E-mail" 
                    type="email" 
                    :rules="emailRules" 
                    v-model="credentials.username"
                    :error="error"
                    :error-messages="errors['message']"
                    @keyup.enter="login"
                    >
                  </v-text-field>
                  <v-text-field id="password" prepend-icon="lock" name="password" label="Geslo" type="password" :rules="passwordRules" v-model="credentials.password" @keyup.enter="login"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="white--text" dark color="light-blue darken-3" @click.native="login" :loading="loginLoading">Prijava</v-btn>
                <!--<v-btn dark color="light-blue darken-3" @click.native='passwordReset'>Pozabljeno geslo?</v-btn>-->
                <br><br>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import router from '../.././router'
import Store from '../.././store'
import { post } from '../../helpers/api'

  export default {
    data: () => ({
      drawer: null,
      title: "Prijava",
      tile: true,
      avatarSize: 32,
      valid: true,
      credentials: {
        username: '',
        password: '',
      },
      emailRules: [
        (v) => !!v || 'Elektronski naslov je obvezen.',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vneseni elektronski naslov ni veljaven.'
      ],
      passwordRules: [
        (v) => !!v || 'Geslo je obvezno.',
        (v) => v.length >= 6 || 'Geslo mora vsebovati vsaj 6 mestni zapis.'
      ],

      loginLoading: false,
      error: false,
      errors: {}
    }),
    props: {
      source: String
    },

    methods: {

       login() {
         if(this.$refs.loginForm.validate()) {
            this.loginLoading = true;
            this.error = false;
            this.errors = {}
            this.credentials.grant_type = "password";
            this.credentials.client_id = "2";
            this.credentials.client_secret = "Dt8n1kTgQV5hyifFbFFVWgGd55D8FtPYVp4SBTqi";
            this.credentials.scope = "";

            this.$store.dispatch('LOGIN', this.credentials)
              .then(response => {
                router.push({ name: 'home'})
              })
              .catch(error => {
                window.console.log("Error")
                window.console.log(error.response)
                window.console.log(error)
                this.error = true;
                if(error.response.status == 401) {
                  this.errors = { message: "Napačno uporabniško ime ali geslo." }
                }
                else {
                  this.errors = { message: "Pri prijavi v sistem je prišlo do napake."}
                }
                this.loginLoading = false;
              })
              .then(() => {
                this.loginLoading = false;
              })
         }
       }
      }
    }
  
</script>

<style scoped>
  html { overflow-y: auto !important; }
</style>
